import './PodAd.scss';

import { IconDrag } from '@hulu-react-style-components/icons';
import React from 'react';
import { Draggable } from 'react-beautiful-dnd';

import bem from '../../../utils/bem';
import type { SequenceAdV5 } from '../types';

const [block, element] = bem('pod-ad');

type PodAdProps = {
  ad: SequenceAdV5;
  index: number;
};

const PodAd = ({ ad, index }: PodAdProps): JSX.Element => (
  <Draggable draggableId={`pod-item-${ad.id}`} index={index}>
    {(dragProvided, dragSnapshot): React.ReactElement => (
      <div
        className={block(dragSnapshot.isDragging ? 'dragging' : null)}
        ref={dragProvided.innerRef}
        {...dragProvided.draggableProps}
      >
        <span className={element('drag-handle')} {...dragProvided.dragHandleProps}>
          <IconDrag />
        </span>
        <span className={element('name')} title={ad.name}>
          {ad.name}
        </span>
      </div>
    )}
  </Draggable>
);

export default PodAd;
